/* global Routes, rwgps, google */

import React from 'react'
import ReactDOM from 'react-dom'
import {LeftSidebar} from './LeftSidebar'
import {RightSidebar} from './RightSidebar'
import {List} from 'immutable'
import _ from 'lodash'

export class CueReviewTool extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      currentCue: null,
      previousCommand: props.plannerSidebar && props.plannerSidebar.instance.currentCommand()
    }
  }

  getCues = () => {
    return List(this.props.cues)
  }

  getPrevCueIndex = (cue) => {
    const {currentCue} = this.state
    const cues = this.getCues()
    const currentCueIndex = cues.indexOf(cue || currentCue)

    return currentCueIndex > 0 ? _.findLastIndex(cues.toArray(), c => !c.deleted, currentCueIndex - 1) : -1
  }

  getNextCueIndex = (cue) => {
    const {currentCue} = this.state
    const cues = this.getCues()
    const currentCueIndex = cues.indexOf(cue || currentCue)

    return currentCueIndex < cues.size - 1 ? _.findIndex(cues.toArray(), c => !c.deleted, currentCueIndex + 1) : cues.size
  }

  componentDidMount = () => {
    const {route, plannerSidebar} = this.props

    Routes.activeMap.callWhenReady(() => Routes.activeMap.setOption('show_coursepoint_icons', true))

    plannerSidebar && plannerSidebar.unmountComponent && plannerSidebar.unmountComponent()

    this.cleanRoute(route)

    const cues = this.getCues()
    if (cues.every((c) => c.confirmed)) {
      this.cuePicked(cues.first())
    } else {
      this.goToFirstUnconfirmed()
    }
  }

  cleanRoute = (route) => {
    // Sometimes a route can have segments that start and stop at the same controlpoint, so let's slurp those up
    let seg = route.firstSegment
    while (seg) {
      if (seg.nextSegment && seg.nextSegment.prevControlPoint.distance === seg.nextSegment.nextControlPoint.distance) {
        seg.slurpNext()
      } else {
        seg = seg.nextSegment
      }
    }
  }

  componentWillUnmount = () => {
    Routes.activeMap.callWhenReady(() => Routes.activeMap.setOption('show_coursepoint_icons', document.getElementById('opt_show_coursepoint_icons').checked))
  }

  cuePicked = (cue) => {
    if (!cue) return

    this.setState({
      currentCue: cue
    })
  }

  highlightCurrentSlice = (slice, currentCue, skipZoom) => {
    const {route} = this.props

    // Guard against some bad data
    if (!slice.right || !slice.left) return

    const directionArrow = {
      path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
      strokeColor: '#424242',
      strokeOpacity: '1',
      strokeWeight: rwgps.Route.DEFAULT_LINE_WIDTH * 1.5,
      scale: rwgps.Route.DEFAULT_LINE_WIDTH * 1.5
    }

    var highlightCircle = {
      path: google.maps.SymbolPath.CIRCLE,
      strokeColor: '#FF8200',
      strokeOpacity: '.8',
      fillColor: '#FF8200',
      fillOpacity: '.5',
      strokeWeight: rwgps.Route.DEFAULT_LINE_WIDTH * 1,
      scale: rwgps.Route.DEFAULT_LINE_WIDTH * 8
    }

    // These distances are all relative to the current slice
    const totalDistance = slice.right.distance - slice.left.distance
    const leftDistance = currentCue.trackPoint.distance - slice.left.distance
    const rightDistance = slice.right.distance - currentCue.trackPoint.distance
    const leftArrowDistance = (leftDistance) / 2
    const rightArrowDistance = currentCue.trackPoint.distance - slice.left.distance + (rightDistance) / 2
    const currentCueDistance = currentCue.trackPoint.distance - slice.left.distance

    const polylineOptions = {
      strokeColor: '#fc7efa',
      strokeOpacity: '.5',
      strokeWeight: rwgps.Route.DEFAULT_LINE_WIDTH * 5,
      icons: [
        {
          icon: directionArrow,
          offset: ((leftArrowDistance / totalDistance) * 100) + '%'
        },
        {
          icon: directionArrow,
          offset: ((rightArrowDistance / totalDistance) * 100) + '%'
        },
        {
          icon: highlightCircle,
          offset: ((currentCueDistance / totalDistance) * 100) + '%'
        }
      ]
    }

    rwgps.highlightDataSlice(slice, skipZoom, polylineOptions)
    Routes.sampleGraph.identifySegment(slice)

    // To set the zoom on the map, we are going to take the shorter of the two lengths (left to cue, and cue to right), multiply it by 3, and use that result to limit the length of the longer leg we try and fit in the screen.  This means for shorter turns after a long stretch, like where the route has no cues for a 1 mile then has two quick turns, we generally display those two close together cues with enough context and space to properly review.
    const shorterDistance = Math.min(leftDistance, rightDistance)
    const maxZoomDistance = shorterDistance * 3
    const leftZoomDistance = Math.max(slice.left.distance, currentCue.trackPoint.distance - maxZoomDistance)
    const rightZoomDistance = Math.min(slice.right.distance, currentCue.trackPoint.distance + maxZoomDistance)
    let leftZoomIndex = route.trackPoints().findIndex((p) => p.distance >= leftZoomDistance)
    if (leftZoomIndex < 0) {
      leftZoomIndex = 0
    }
    let rightZoomIndex = route.trackPoints().findIndex((p) => p.distance > rightZoomDistance)
    if (rightZoomIndex < leftZoomIndex || rightZoomIndex < 1) {
      rightZoomIndex = route.trackPoints().length - 1
    }
    if (leftZoomIndex === rightZoomIndex) {
      leftZoomIndex = 0
      rightZoomIndex = route.trackPoints().length - 1
    }
    !skipZoom && rwgps.zoomToPoints(leftZoomIndex, rightZoomIndex)
  }

  clearAutomaticallyAddedControlPoints () {
    const cues = this.getCues()
    cues.forEach((cue) => {
      if (!cue.trackPoint.segment && cue.trackPoint.prevSegment) {
        cue.trackPoint.prevSegment.slurpNext()
      }
    })
  }

  sortByTPIndexAscending = (a, b) => {
    return a.trackPointIndex - b.trackPointIndex
  }

  sortByTPIndexDescending = (a, b) => {
    return b.trackPointIndex - a.trackPointIndex
  }

  onConfirm = (cueUpdates) => {
    const {currentCue} = this.state
    const cues = this.getCues()

    const currentCueIndex = cues.indexOf(currentCue)
    const newCue = Object.assign(currentCue, cueUpdates, {edited: true, confirmed: true})

    const newCues = cues.set(currentCueIndex, newCue)
    rwgps.Events.trigger('cp:populate', newCues.toArray())

    const nextCue = newCues.sort(this.sortByTPIndexAscending).find((c) => (c.trackPointIndex > newCue.trackPointIndex && !c.deleted))

    this.cuePicked(nextCue)
  }

  onPrevious = () => {
    const {currentCue} = this.state
    const cues = this.getCues()
    // On a reversed list of cues, the first one we 'find()' with a lower trackpoint index is going to be the previous cue
    const previousCue = cues.sort(this.sortByTPIndexDescending).find((c) => (c.trackPointIndex < currentCue.trackPointIndex && !c.deleted))
    this.cuePicked(previousCue)
  }

  onDelete = (cueUpdates, deleted) => {
    const {route} = this.props
    const {currentCue} = this.state
    const cues = this.getCues()

    const currentCueIndex = cues.indexOf(currentCue)
    const newCue = Object.assign(currentCue, cueUpdates, {deleted: deleted !== false})

    const newCues = cues.set(currentCueIndex, newCue)
    rwgps.Events.trigger('cp:populate', newCues.toArray())

    // we are probably changing the icon we want want the coursepoint to use
    if (newCue.marker && currentCue.marker.gmarker) {
      newCue.marker.gmarker.setMap(null)
      delete newCue.marker
      route.map.drawCoursePointIcons([newCue])
    }

    this.setState({currentCue: newCue})
  }

  removeCues = () => {
    const {route} = this.props

    // Filter out soft-deleted cues
    const cues = this.getCues().filter(function (cue) {
      if (cue.deleted) {
        cue.segment.removeCoursePoint(cue)
      }
      return cue.deleted !== true
    })

    route.map.drawCoursePointIcons(cues.toArray())
  }

  onClose = () => {
    const {route} = this.props
    const {previousCommand} = this.state

    this.removeCues()

    this.clearAutomaticallyAddedControlPoints()
    route.segments.forEach(function (segment) {
      segment.drawInactive = false
    })
    this.resetCueIcons(this.getCues())

    rwgps.unhighlightPoints(true)
    Routes.sampleGraph.unidentifySegment()

    route.redrawPolylines()

    /* enable some dragging */
    route.map.nearestPointMarker && route.map.nearestPointMarker.gmarker.setDraggable(true)
    route.startMarker && route.startMarker.gmarker && route.startMarker.gmarker.setDraggable(false)
    route.endMarker && route.endMarker.gmarker && route.endMarker.gmarker.setDraggable(false)

    // Callback from new.js
    this.props.unmountComponent()
    this.props.closeCueReview(previousCommand)

    route.map.inCueReview = false
    route.clearControlPoints()
    route.drawControlPoints(route.map)
    Routes.Common.updateMetrics(route.metrics, false)
  }

  goToFirstUnconfirmed = () => {
    const cues = this.getCues()
    const firstUnconfirmed = cues.find((c) => c.confirmed !== true)
    this.cuePicked(firstUnconfirmed)
  }

  resetCueIcons = (cues) => {
    cues.forEach(function (c) {
      c.selected = false
      if (c.marker && c.marker.gmarker) {
        c.marker.gmarker.setMap(null)
        delete c.marker
      }
    })
  }

  getPrevCoursePoint = (cue) => {
    const cues = this.getCues()

    const prevCueIndex = this.getPrevCueIndex()
    if (prevCueIndex >= 0) {
      return cues.get(prevCueIndex)
    }
  }

  getNextCoursePoint = (cue) => {
    const cues = this.getCues()

    const nextCueIndex = this.getNextCueIndex()
    if (nextCueIndex < cues.size) {
      return cues.get(nextCueIndex)
    }
  }

  syncToMap = (previousCue, skipZoom) => {
    const {route} = this.props
    const {currentCue} = this.state

    const cues = this.getCues()

    // auto-add control points to the route if necessary
    this.clearAutomaticallyAddedControlPoints()
    const prevCoursePoint = this.getPrevCoursePoint(currentCue)
    if (prevCoursePoint && prevCoursePoint.trackPoint.segment) {
      const prevTrackPoint = prevCoursePoint.trackPoint
      const segmentI = prevTrackPoint.segment.trackPoints.indexOf(prevTrackPoint)
      prevTrackPoint.segment.splitAfter(segmentI - 1)
    }
    const nextCoursePoint = this.getNextCoursePoint(currentCue)
    if (nextCoursePoint && nextCoursePoint.trackPoint.segment) {
      const nextTrackPoint = nextCoursePoint.trackPoint
      const segmentI = nextTrackPoint.segment.trackPoints.indexOf(nextTrackPoint)
      nextTrackPoint.segment.splitAfter(segmentI - 1)
    }

    /* draw the selected segments as active */
    route.segments.forEach(function (segment) {
      segment.drawInactive = true
    })
    let segment = prevCoursePoint ? prevCoursePoint.trackPoint.nextSegment : route.firstSegment
    while (segment && segment !== (nextCoursePoint && nextCoursePoint.trackPoint.nextSegment)) {
      segment.drawInactive = false
      segment = segment.nextSegment
    }
    route.redrawPolylines()

    /* redraw selected coursepoint */
    this.resetCueIcons(cues)
    currentCue.selected = true
    route.map.removeCoursePointIcons(cues.toArray())
    const previousCueIndex = this.getPrevCueIndex()
    const nextCueIndex = this.getNextCueIndex()
    // TODO: add in special handling so I manually draw the current coursePoint, so I can get rid of the .selected variable
    route.map.drawCoursePointIcons(cues.slice(previousCueIndex > 0 ? previousCueIndex : 0, nextCueIndex + 1).toArray())

    /* disable some dragging */
    route.clearControlPoints()
    route.map.nearestPointMarker && route.map.nearestPointMarker.gmarker.setDraggable(false)
    route.startMarker && route.startMarker.gmarker && route.startMarker.gmarker.setDraggable(false)
    route.endMarker && route.endMarker.gmarker && route.endMarker.gmarker.setDraggable(false)

    /* Update map */
    const trackPoints = route.trackPoints()
    const previousTrackPointIndex = prevCoursePoint ? trackPoints.indexOf(prevCoursePoint.trackPoint) : 0
    const nextTrackPointIndex = nextCoursePoint ? trackPoints.indexOf(nextCoursePoint.trackPoint) : trackPoints.length - 1
    const currentSlice = new rwgps.DataSlice(Routes.sampleGraph, previousTrackPointIndex, 1 + nextTrackPointIndex - previousTrackPointIndex)
    this.highlightCurrentSlice(currentSlice, currentCue, skipZoom)
  }

  componentDidUpdate = (prevProps, prevState) => {
    const {route, cues} = this.props

    // If there are no cues anymore, something happened outside this review tool and we can't even
    if (prevProps.cues.length === 0 || cues.length === 0) {
      return
    }

    this.cleanRoute(route)

    const newCues = List(cues).map((c) => c.distance).toSet()
    const oldCues = List(prevProps.cues).map((c) => c.distance).toSet()
    const skipZoom = newCues.subtract(oldCues).size !== 0

    this.syncToMap(prevState.currentCue, skipZoom)
  }

  render () {
    const {route} = this.props
    const {currentCue} = this.state
    const cues = this.getCues()

    return [(<LeftSidebar key={'uniqueLeftSidebarKey'} route={route} cues={cues} currentCue={currentCue} cuePicked={this.cuePicked} />),
      (
        currentCue && ReactDOM.createPortal(<RightSidebar cues={cues} currentCue={currentCue} onConfirm={this.onConfirm} onPrevious={this.onPrevious} onClose={this.onClose} onDelete={this.onDelete} removeCues={this.removeCues} cuePicked={this.cuePicked} />, document.getElementById('rightCueReview'))
      )]
  }
}
